<template>
  <v-dialog v-model="visible" width="500" @keydown.esc="visible = false">
    <v-card>
      <v-card-title>
        <div class="headline">Leaving {{ title }}</div>
        <v-spacer></v-spacer>
        <v-btn text icon @click="visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text text-xs-center> Are you sure you want to Exit? </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="!globalLoad">
          <v-btn text color="red darken-1" @click="visible = false">No</v-btn>
          <v-btn text color="primary" @click.native="$emit('exit')">Yes</v-btn>
        </div>
        <div v-else>
          <v-btn text key="loadingBtn" color="primary" :loading="true">Loading</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  computed: {
    globalLoad() {
      // check if Claim is in loading/saving state
      return this.$store.state.claims.claimDetail.saving
    }
  },
  watch: {
    value: function (value) {
      this.visible = value
    },
    visible: function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
</style>
